/*
 * File: /src/main.js
 * Created Date: Tuesday February 12th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 6th April 2019 8:08:12 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import './assets/sass/demo.scss';
import './assets/sass/paper-dashboard.scss';
import './registerServiceWorker';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import fonts from './fontAwesomeIcons.js';
import ElementPlus from 'element-plus';
import Notifications from '@kyvg/vue3-notification';
import VueApexCharts from 'vue3-apexcharts';
import App from './App.vue';
import router from './router';
import store from './store/index.js';

// Vuetify
import 'vuetify/styles';
import 'src/assets/sass/vuetify-labs.scss';
import vuetify from './vuetify';

// Converted
import SideBar from './components/UIComponents/SidebarPlugin';
import sidebarLinks from './sidebarLinks';

// Mixin TODO: Convert to composition functions, explicit is good
// - been reusing functions allover.
import PhoneMixin from './mixins/phone';
import DatesMixin from './mixins/dates';
import CurrencyMixin from './mixins/currency';
import GlobalDirectives from './globalDirectives';
import CallAgentPlugin from './components/UIComponents/CallAgentPlugin';
import SendLoading from './components/UIComponents/LoadingPlugin';
import GlobalSearch from './components/UIComponents/SearchPlugin';
import VueCanva from './components/Plugins/canva';

import { createApp } from 'vue';

const app = createApp({
  ...App,
});
app.use(store);
app.use(router);
// For backwards compat with old vue2 access patterns
router.app = app;

// Convert these to be explicit compositions
app.mixin(PhoneMixin);
app.mixin(DatesMixin);
app.mixin(CurrencyMixin);

// Register envs for access in containerized runs
app.config.globalProperties.s2Config = window.s2Config;

app.component('font-awesome-icon', FontAwesomeIcon);

app.use(GlobalDirectives);
app.use(Notifications);
app.use(SideBar, { sidebarLinks: sidebarLinks });
app.use(ElementPlus);
app.use(VueApexCharts);
app.use(CallAgentPlugin);
app.use(SendLoading);
app.use(GlobalSearch);
app.use(VueCanva, { key: 's6NTYJjjLhkGRULXbx9cO3yk' });
app.use(vuetify);

app.mount('#app');

/*
 * Need to find a new way to make the Idle logout work with vue3
  computed: {
    isActive() {
      return this.isAppIdle;
    }
  },
  watch: {
    isActive(n, o) {
      let tenMinutes = 1000 * 60 * 10;
      let oneHour = 1000 * 60 * 60;
      let nineHours = oneHour * 9;
      if (
        n === false ||
        this.$store.getters['auth/getLoginStatus'] === false ||
        this.$store.getters['auth/getLongTokenMode'] ===  true
      ) {
        return;
      }

      let autoLogout;
      let box = this.$alert(
        'You are about to be logged out for non-use.  Click cancel to stop this.',
        'SendSquared Security',
        {
          confirmButtonText: 'Cancel',
          callback: action => {
            clearTimeout(autoLogout);
          }
        }
      );
      autoLogout = setTimeout(async () => {
        try {
          await AgentService.logout();
        } catch (e) {
          // Expect error if they are not an agent
        }
        this.$store.dispatch('auth/logout');
        this.$router.push('/login');
        // try to close the box
        ElementUI.MessageBox.close();
      }, tenMinutes);
    }
  }
});
*/

// Make globals available in non vue js files, ie services
const globals = app.config.globalProperties;
export default globals;
